import PropTypes from 'prop-types'
import classes from './SutStatusBadge.module.scss'

const getText = (isEnabled, isLocked) => {
  if (!isEnabled) {
    return 'Disabled'
  }

  if (isLocked) {
    return 'Locked'
  }

  return 'Available'
}

const SutStatusBadge = ({
  isEnabled,
  isLocked
}) => {
  const text = getText(isEnabled, isLocked)

  return (
    <span className={[classes.SutStatusBadge, classes['SutStatusBadge' + text]].join(' ')}>
      {text}
    </span>
  )
}

SutStatusBadge.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired
}

export default SutStatusBadge
